import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { AuthStateService } from '../auth/auth-state.service';
import { BillingService } from './billing.service';

/** Matches backend SUBSCRIPTION_OK — past_due is grace. */
const SUBSCRIPTION_OK = new Set(['active', 'trialing', 'past_due']);

/**
 * Frontend mirror of the paid gate.
 * environment.showBilling false → free for client tenants (no FE subscription checks).
 * true → Payments UI + post-login/rates guard + 402 Billing link.
 * Irish Taylor staff are always exempt. Backend SF_REQUIRE_SUBSCRIPTION must match.
 */
@Injectable({ providedIn: 'root' })
export class SubscriptionGateService {
  private readonly billing = inject(BillingService);
  private readonly authState = inject(AuthStateService);

  /** Client paywall + Payments page. Off = features free on the FE. */
  isClientBillingEnabled(): boolean {
    return environment.showBilling === true;
  }

  isSubscriptionOk(status: string | null | undefined): boolean {
    return SUBSCRIPTION_OK.has((status || 'none').toLowerCase());
  }

  /**
   * After sign-in: rates when billing off / staff / paid; Billing when gated & unpaid.
   */
  postLoginUrl(): Observable<string> {
    if (!this.isClientBillingEnabled() || this.authState.isITStaff()) {
      return of('/app/smartfreight/rates');
    }
    return this.billing.getStatus().pipe(
      map((s) =>
        this.isSubscriptionOk(s.status) ? '/app/smartfreight/rates' : '/app/billing'
      ),
      catchError(() => of('/app/billing'))
    );
  }
}
